import { render, staticRenderFns } from "./classwiseduechart.vue?vue&type=template&id=761b950b&"
import script from "./classwiseduechart.vue?vue&type=script&lang=js&"
export * from "./classwiseduechart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports